<template>
  
  <div class="group" ref="wallSpaceGroup">

    <div class="group-header">
      <div class="group-title" :id="`${builder.wallSpace.fieldName}Title`">What type of wall space do you have?</div>
    </div>

    <Plan-Selector
      :key=builder.wallSpace.fieldName
      :field-name=builder.wallSpace.fieldName
      :display-type=displayType
      :options=builder.wallSpace.options
      :selected=builder.currentItem.specs[builder.wallSpace.fieldName]
      options-source="wallSpaceOptions"
      scope="specs"
      @select-option="select"
    ></Plan-Selector>

  </div>
  
</template>

<script setup>
  
import { ref, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();




const displayType = computed(() => {
  return ['visual', 'interiors', 'duo', 'frameless', 'wallspace', 'image-and-plan'];
})

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);

  // one-click continue
  builder.saveCurrentItem(true); 
}

// init refs
const wallSpaceGroup = ref(null);
builder.refs['wallSpaceGroup'] = wallSpaceGroup;
</script>